import { render, staticRenderFns } from "./horizontal.vue?vue&type=template&id=854919e8&scoped=true"
import script from "./horizontal.vue?vue&type=script&lang=js"
export * from "./horizontal.vue?vue&type=script&lang=js"
import style0 from "./horizontal.vue?vue&type=style&index=0&id=854919e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854919e8",
  null
  
)

export default component.exports